import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=07d8046c&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=ts"
export * from "./Dashboard.vue?vue&type=script&lang=ts"
import style0 from "./Dashboard.vue?vue&type=style&index=0&id=07d8046c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d8046c",
  null
  
)

export default component.exports